import { motion } from 'framer-motion'
import CloseBubbleIcon from '../../../../assets/svgs/CloseBubble'
import EditIcon from '../../../../assets/svgs/EditIcon'
import PlusCircleIcon from '../../../../assets/svgs/PlusCircle'
import style from './MainProfile.module.css'

/* Proficiency → filled dots */
const proficiencyMap = {
  Elementary: 1,
  Beginner: 1,
  'Limited Working': 2,
  'Professional Working': 3,
  'Full Professional': 4,
  'Native or Bilingual': 5,
  Native: 5,
  Bilingual: 5,
  Advanced: 4,
  Intermediate: 3,
}

const ProfDots = ({ proficiency }) => {
  const filled = proficiencyMap[proficiency] ?? 3
  return (
    <span className={style.profDots}>
      {Array.from({ length: 5 }).map((_, i) => (
        <span
          key={i}
          className={`${style.dot} ${i < filled ? style.dotFilled : style.dotEmpty}`}
        />
      ))}
    </span>
  )
}

const fadeUp = {
  hidden: { opacity: 0, scale: 0.88, y: 6 },
  visible: (i = 0) => ({
    opacity: 1, scale: 1, y: 0,
    transition: { duration: 0.32, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] },
  }),
}

const Languages = ({ userProfile, toggleModal, owner, removeComponent, editMode }) => {
  if (!userProfile.languages?.length) return null

  return (
    <div className={style.skillsWrapper}>
      <div className={style.experienceActions}>
        <p className={style.title}>Languages</p>
        {owner && editMode && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <div
              className={style.plus}
              onClick={() => toggleModal('language', userProfile, 'create')}
              title="Add language"
            >
              <PlusCircleIcon color="white" />
            </div>
            <div
              onClick={() => removeComponent('5')}
              style={{ cursor: 'pointer', opacity: 0.65 }}
              title="Remove section"
            >
              <CloseBubbleIcon color="#393D63" height={20} width={20} />
            </div>
          </div>
        )}
      </div>

      <motion.div
        className={style.skillsGrid}
        initial="hidden"
        animate="visible"
        variants={{ visible: { transition: { staggerChildren: 0.05 } } }}
      >
        {userProfile.languages.map((item, index) => (
          <motion.div
            className={style.skill}
            key={index}
            variants={fadeUp}
            custom={index}
          >
            <span className={style.skillName}>{item.language}</span>
            {item.proficiency && <ProfDots proficiency={item.proficiency} />}
            {item.proficiency && (
              <span className={style.subtext}>{item.proficiency}</span>
            )}
            {owner && editMode && (
              <div
                onClick={() => toggleModal('language', item)}
                className={style.edit}
                title="Edit"
              >
                <EditIcon />
              </div>
            )}
          </motion.div>
        ))}
      </motion.div>
    </div>
  )
}

export default Languages
